module.exports = __webpack_public_path__ + "d04ea3df41191c38aa2ca94e8c0a6a8f.png";